import React, { Component } from 'react';

import './ListaCalibraciones.css';

import {
  getCalibraciones,
  clearErrors,
  deleteCalibracion,
  subirReporteCalibracion,
  deleteDataCalibracion,
} from '../../../redux/actions/dataactions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FaArrowLeft, FaPlus } from 'react-icons/fa';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AttachFileIcon from '@mui/icons-material/AttachFile';

import { useDropzone } from 'react-dropzone';

const FileDropzone = ({ onFileDrop }) => {
  const { getRootProps, getInputProps, acceptedFiles, fileRejections } = useDropzone({
    accept: {
      'application/pdf': ['.pdf'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
    },
    maxFiles: 1,
    onDrop: onFileDrop
  });

  return (
    <div className="dropzone-container mt-4">
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <p className="dropzone-text">Arrastra y suelta el archivo aquí, o haz clic para seleccionarlo</p>
        <em className="dropzone-info">(Solo se permite subir un archivo PDF, DOC o DOCX)</em>
      </div>

      <aside className="dropzone-preview">
        {fileRejections.length > 0 && (
          <div className="file-error">
            <h4>Solo se puede cargar un archivo</h4>
          </div>
        )}

        {acceptedFiles.length > 0 && (
          <div className="file-accepted-dropzone">
            <h4 className='text-file-dropzone'>Archivo a cargar:</h4>
            <ul className="file-list-dropzone">
              {acceptedFiles.map(file => (
                <li key={file.path} className="file-item-dropzone">
                  {file.path} - {file.size} bytes
                </li>
              ))}
            </ul>
          </div>
        )}
      </aside>
    </div>
  );
};

export class ListaCalibraciones extends Component {
  constructor(){
    super();
    this.state={
      selectedFile: null,
      progid:'',
      openatach: false,
      open:false,
      opendelete:false,
      fecha:'',
      horainicio:'',
      horafinal:'',
      numcertificado:'',
      reporteurl:'',
      reportefilename:'',
      calibracionid:'',
    }
  }
  

  componentDidMount(){
    this.props.getCalibraciones(this.props.equipoId);
   }

handleDrop = (acceptedFiles) => {
  if (acceptedFiles && acceptedFiles.length > 0) {
    this.setState({ selectedFile: acceptedFiles[0] });
  }
};
//Subir Reporte ATACH
handleOpenAtach=(rawdataprogid)=>{
    this.setState({openatach:true,progid:rawdataprogid});
  
};

onFileChange = event => { 
  // Update the state 
  this.setState({ selectedFile: event.target.files[0] }); 
 
}; 
onFileUpload = () => { 
  const { selectedFile } = this.state;
  if (!selectedFile) return; // evita subir sin archivo

  const formData = new FormData(); 
  formData.append("myFile", selectedFile, selectedFile.name); 

  this.props.subirReporteCalibracion(
    formData,
    this.props.equipoId,
    this.props.clienteId,
    this.state.progid
  );

  this.setState({ openatach: false, selectedFile: null });
}; 

handleCloseAtach = () => {
  this.setState({ openatach: false, selectedFile: null });
};
//********************Ver reporte

handleOpen=(rawdata)=>{
  this.mapUserDetailsToState(rawdata);
  this.setState({open:true})
}
handleClose=()=>{
  this.setState({open:false});
};

mapUserDetailsToState = (calibracion) => {
  this.setState({
    fecha:calibracion.fecha?calibracion.fecha:'',
    horainicio:calibracion.horainicio?calibracion.horainicio:'',
    horafinal:calibracion.horafinal?calibracion.horafinal:'',
    numcertificado:calibracion.numcertificado?calibracion.numcertificado:'',
    reporteurl:calibracion.reporteurl?calibracion.reporteurl:'',
    
    
  });
};


//******borrar Reporte de Calibración */
handleOpenDelete=(rawdata)=>{
  this.setState({opendelete:true,
     reportefilename:rawdata.reportefilename,
    calibracionid:rawdata.calibracionid,  
  });
 
  };


handleCloseDelete=()=>{
  // this.props.clearErrors();
   this.setState({opendelete:false});
   };


handleDelete=()=>{

this.props.deleteCalibracion(this.state.calibracionid,this.props.equipoId);

this.handleCloseDelete();
}

   
    

render() {
    const { calibraciones, loadingcal } = this.props.data;

    const rows = calibraciones.map((cal) => ({ id: cal.calibracionid, ...cal }));

    const columns = [
      {
        field: 'acciones',
        headerName: 'Acciones',
        width: 200,
        sortable: false,
        renderCell: (params) => (
          <>
            <Tooltip title="Reporte de Calibración">
              <IconButton size="small" onClick={() => this.handleOpen(params.row)} sx={{ color: '#03178C' }}>
                <AssignmentIcon  />
              </IconButton>
            </Tooltip>
            <Tooltip title="Adjuntar Certificado PDF" sx={{ color: '#03178C' }}>
              <IconButton
                size="small"
                onClick={() => this.handleOpenAtach(params.row.calibracionid)}
              >
                <AttachFileIcon  />
              </IconButton>
            </Tooltip>
            <Tooltip title="Borrar Calibración">
              <IconButton size="small" onClick={() => this.handleOpenDelete(params.row)}>
                <DeleteOutlineIcon />
              </IconButton>
            </Tooltip>
          </>
        ),
      },
      { field: 'fecha', headerName: 'Fecha', width: 200 },
      { field: 'numcertificado', headerName: 'No. Certificado', width: 200 },
      {
        field: 'reporteurl',
        headerName: 'Link Certificado',
        width: 200,
        renderCell: (params) =>
          params.value === 'false' ? (
            <span>Sin Certificado Adjunto</span>
          ) : (
            <a href={params.value} target="_blank" rel="noopener noreferrer">
              Link del Certificado
            </a>
          ),
      },
    ];

    const mapeocalibraciones = !loadingcal ? (
      <Box>
         <Typography sx={{ fontSize: '16px', color: '#03178c', fontWeight: 600 }}>
                  Calibraciones Realizadas
                </Typography>
        <DataGrid
          rows={rows}
          columns={columns}
          disableRowSelectionOnClick
          sx={{
            height: 500,
            width: '100%',
            mt: 2,
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: 'primary.main',
              color: 'white',
            },
          }}
          components={{
            Toolbar: () => (
              <Box p={1}>
                <GridToolbarQuickFilter placeholder="Buscar..." />
              </Box>
            ),
          }}
        />
      </Box>
    ) : (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress size={50} color="primary" />
      </Box>
    );

    let linkcalibracion =
      this.state.reporteurl === 'false' ? (
        <a>Sin Certificado Adjunto</a>
      ) : (
        <a href={this.state.reporteurl} target="_blank" rel="noopener noreferrer">
          Link del Certificado
        </a>
      );

    return (
      <div className="listamtoprog-container">
        <div className="listamtoprog-table">{mapeocalibraciones}</div>

        <Dialog
          open={this.state.openatach}
          onClose={this.handleCloseAtach}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            <Typography
              sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}
            >
              Subir Certificado de Calibración
            </Typography>
          </DialogTitle>
         <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FileDropzone onFileDrop={this.handleDrop} />
            </Grid>
          </Grid>
        </DialogContent>
          <DialogActions>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleCloseAtach}>
                <FaArrowLeft color="#D3D7DC" />
              </IconButton>
            </Tooltip>

            <Tooltip title={this.state.selectedFile ? "Subir Certificado" : "Selecciona un archivo"}>
              <span>
                <IconButton onClick={this.onFileUpload} disabled={!this.state.selectedFile}>
                  <FaPlus color={this.state.selectedFile ? "#03178C" : "#BDBDBD"} />
                </IconButton>
              </span>
            </Tooltip>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.open} onClose={this.handleClose} fullWidth maxWidth="sm">
          <DialogTitle>
            <Typography
              sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}
            >
              Reporte de Calibración
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12} mt={2}>
                <TextField
                  required
                  type="date"
                  name="fecha"
                  id="fecha"
                  label="Fecha de Realización"
                  value={this.state.fecha}
                  onChange={this.handleChange}
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  required
                  type="time"
                  name="horainicio"
                  id="horainicio"
                  label="Hora de Inicio"
                  value={this.state.horainicio}
                  onChange={this.handleChange}
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  required
                  type="time"
                  name="horafinal"
                  id="horafinal"
                  label="Hora Final"
                  value={this.state.horafinal}
                  onChange={this.handleChange}
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  type="text"
                  name="numcertificado"
                  id="numcertificado"
                  label="Numero del Certificado"
                  value={this.state.numcertificado}
                  onChange={this.handleChange}
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12}>{linkcalibracion}</Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleClose}>
                <FaArrowLeft color="#D3D7DC" />
              </IconButton>
            </Tooltip>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.opendelete}
          onClose={this.handleCloseDelete}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            <Typography
              sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}
            >
              Estas seguro de borrar esta Calibración?
            </Typography>
          </DialogTitle>
          <DialogActions>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleCloseDelete}>
                <FaArrowLeft color="#D3D7DC" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Borrar Calibración">
              <IconButton onClick={this.handleDelete}>
                <FaPlus color="#03178C" />
              </IconButton>
            </Tooltip>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

ListaCalibraciones.propTypes = {
  getCalibraciones: PropTypes.func.isRequired,
  subirReporteCalibracion: PropTypes.func.isRequired,
  deleteCalibracion: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  deleteDataCalibracion: PropTypes.func.isRequired,
};

const mapActionsToProps={getCalibraciones,clearErrors,deleteCalibracion,deleteDataCalibracion,subirReporteCalibracion};

const mapStateToProps = (state)=>({
    data:state.data,
    UI:state.UI
})



export default connect(mapStateToProps,mapActionsToProps)(ListaCalibraciones);

